"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _DqSpinner = _interopRequireDefault(require("../DqSpinner/DqSpinner"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * Loading indicator
 */
const DqLoading = ({
  className,
  fullScreen,
  message
}) => /*#__PURE__*/React.createElement("div", {
  className: (0, _classnames.default)("dq-flex dq-items-center dq-justify-center dq-text-3xl", {
    "dq-absolute dq-top-0 dq-left-0 dq-h-full dq-w-full dq-bg-gray-100 dq-bg-opacity-80": fullScreen
  }, className)
}, /*#__PURE__*/React.createElement(_DqSpinner.default, null), message && /*#__PURE__*/React.createElement("div", {
  className: "dq-ml-1"
}, message));

DqLoading.defaultProps = {
  className: "",
  fullScreen: false,
  message: ""
};
var _default = DqLoading;
exports.default = _default;